export enum RouterStateKey {
  ORIGIN = 'origin',
}
